/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venue_Pick_Country_HintInputs */



/**
* | output |
* | --- |
* | "Select a country first to see venue suggestions." |
*
* @param {Venue_Pick_Country_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const venue_pick_country_hint = /** @type {((inputs?: Venue_Pick_Country_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venue_Pick_Country_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez d'abord un pays pour voir des suggestions de lieu.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione primero un país para ver sugerencias de sede.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Selecione primeiro um país para ver sugestões de local.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona prima una nazione per vedere suggerimenti di sede.")
	return /** @type {LocalizedString} */ ("Select a country first to see venue suggestions.")
});